import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsUngatedForSeats } from 'pricing-pages-lib/utils/gatingUtils';
import { FullPriceContainerBlockLarge, MicroCopy, PerMonth } from 'pricing-pages-ui/components/common/pricing/HighlightedPriceDisplay';
import PriceDisplay from 'pricing-pages-ui/components/common/pricing/PriceDisplay';
import { useSelector } from 'react-redux';
import { activeCurrencySelector } from '../../../selectors/CurrencySelectors';
import { usePricingLibSelector } from '../../../selectors/SelectorUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HighlightedFreePriceDisplay = ({
  perMonth = true
}) => {
  const isSeatsRedesignUngated = usePricingLibSelector(getIsUngatedForSeats);
  const currencyCode = useSelector(activeCurrencySelector);
  return /*#__PURE__*/_jsxs("div", {
    style: Object.assign({}, !perMonth ? {
      paddingTop: '18px '
    } : {}),
    children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: perMonth ? 'merchCards.pricing.pricingPerMonthFree_jsx' : 'merchCards.pricing.pricingForeverFree_jsx',
      options: {
        currencyCode,
        price: 0,
        seleniumId: 'free-highlighted-price-per-month'
      },
      elements: {
        MicroCopy,
        PriceContainer: FullPriceContainerBlockLarge,
        PriceDisplay,
        PerMonth
      }
    }), /*#__PURE__*/_jsx(MicroCopy, {
      use: "help",
      children: isSeatsRedesignUngated ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.freeCard.subtexts.seats"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.freeCard.subtexts.default"
      })
    })]
  });
};
export default HighlightedFreePriceDisplay;